import { Routes } from '@angular/router';

export const LOGIN_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('../feature-login/auth-login/auth-login.component').then((c) => c.AuthLoginComponent),
  },
];
